import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/images/upload.svg'
import _imports_1 from '@/assets/images/spin.svg'
import _imports_2 from '@/assets/images/train.svg'
import _imports_3 from '@/assets/images/check.svg'
import _imports_4 from '@/assets/images/no.svg'


const _hoisted_1 = { class: "home flex flex-row pl-16 md:pl-[200px]" }
const _hoisted_2 = { class: "text-white flex-col flex p-5 md:p-10" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "text-[26px]" }, "Source photos", -1)
const _hoisted_4 = { class: "flex-col flex md:flex-row mt-5 justify-start" }
const _hoisted_5 = {
  key: 0,
  class: "max-w-[200px] max-h-[53px] bg-blue-500 my_buy justify-center transition-all flex-row flex font-line font-normal hover:bg-blue-600 text-white py-4 px-8 rounded-xl"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("img", {
  class: "w-5",
  src: _imports_0
}, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "ml-2 text-[14px]" }, "Add photos", -1)
const _hoisted_8 = {
  key: 1,
  class: "bg-teal-500 justify-center transition-all flex-row flex font-line font-normal hover:bg-teal-600 text-white py-4 px-8 rounded-xl"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("img", {
  class: "w-5 animate-spin",
  src: _imports_1
}, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "ml-2 text-[14px]" }, "Training in progress", -1)
const _hoisted_11 = [
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = {
  key: 2,
  class: "bg-teal-500 justify-center transition-all flex-row flex font-line font-normal hover:bg-teal-600 text-white py-4 px-8 rounded-xl"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("img", {
  class: "w-5 animate-spin",
  src: _imports_1
}, null, -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "ml-2 text-[14px]" }, "Uploading", -1)
const _hoisted_15 = [
  _hoisted_13,
  _hoisted_14
]
const _hoisted_16 = {
  key: 3,
  class: "bg-teal-500 justify-center transition-all flex-row flex font-line font-normal hover:bg-teal-600 text-white py-4 px-8 rounded-xl"
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "ml-2 text-[14px]" }, "Ready", -1)
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = {
  key: 4,
  class: "w-full bg-teal-500 md:ml-10 max-w-[200px] md:mt-0 mt-5 justify-center transition-all flex-row flex font-line font-normal hover:bg-teal-600 text-white py-4 px-8 rounded-xl"
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("img", {
  class: "w-5",
  src: _imports_2
}, null, -1)
const _hoisted_21 = ["href"]
const _hoisted_22 = /*#__PURE__*/_createElementVNode("img", {
  class: "w-5",
  src: _imports_2
}, null, -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "ml-2 text-[14px]" }, "Start training", -1)
const _hoisted_24 = [
  _hoisted_22,
  _hoisted_23
]
const _hoisted_25 = {
  key: 0,
  class: "mt-5 text-cool"
}
const _hoisted_26 = {
  key: 1,
  class: "flex-col md:flex-row flex mt-2"
}
const _hoisted_27 = /*#__PURE__*/_createStaticVNode("<div class=\"text-[14px] text-cool\"><div class=\"font-bold text-white mb-5 mt-5\"> Upload 5 high quality photos real photos containing your face. 📸 </div><div class=\"flex-row flex items-center mb-3\"><img class=\"w-5 h-5 mr-5\" src=\"" + _imports_3 + "\"><div> Only one person on photo</div></div><div class=\"flex-row flex items-center mb-3\"><img class=\"w-5 h-5 mr-5\" src=\"" + _imports_3 + "\"><div> Photos in different places, backgrounds</div></div><div class=\"flex-row flex items-center mb-3\"><img class=\"w-5 h-5 mr-5\" src=\"" + _imports_3 + "\"><div> Face fit in image (not cut)</div></div><div class=\"flex-row flex items-center mb-3\"><img class=\"w-5 h-5 mr-5\" src=\"" + _imports_4 + "\"><div> No duplicate photos</div></div><div class=\"flex-row flex items-center\"><img class=\"w-5 h-5 mr-5\" src=\"" + _imports_4 + "\"><div> No effects on photo</div></div></div>", 1)
const _hoisted_28 = [
  _hoisted_27
]
const _hoisted_29 = { class: "flex flex-row flex-wrap justify-start mt-10" }
const _hoisted_30 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Menu = _resolveComponent("Menu")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Menu, { type: "sources" }),
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        (_ctx.status == 'wait_for_photos')
          ? (_openBlock(), _createElementBlock("button", _hoisted_5, [
              _createElementVNode("input", {
                type: "file",
                onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onChange && _ctx.onChange(...args))),
                id: "image_file_input",
                accept: "image/jpeg,image/jpg, image/png, image/heic",
                multiple: true
              }, null, 32),
              _hoisted_6,
              _hoisted_7
            ]))
          : _createCommentVNode("", true),
        (_ctx.status == 'in_progress')
          ? (_openBlock(), _createElementBlock("button", _hoisted_8, _hoisted_11))
          : _createCommentVNode("", true),
        (_ctx.status == 'uploading')
          ? (_openBlock(), _createElementBlock("button", _hoisted_12, _hoisted_15))
          : _createCommentVNode("", true),
        (_ctx.status == 'ready')
          ? (_openBlock(), _createElementBlock("button", _hoisted_16, _hoisted_18))
          : _createCommentVNode("", true),
        (_ctx.status == 'wait_for_photos' && _ctx.paid)
          ? (_openBlock(), _createElementBlock("button", _hoisted_19, [
              _hoisted_20,
              _createElementVNode("div", {
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.start_train())),
                class: "ml-2 text-[14px]"
              }, "Start training")
            ]))
          : _createCommentVNode("", true),
        (_ctx.status == 'wait_for_photos' && !_ctx.paid)
          ? (_openBlock(), _createElementBlock("a", {
              key: 5,
              href: _ctx.g_link,
              target: "_blank",
              class: "max-w-[200px] mt-5 md:mt-0 bg-teal-500 md:ml-10 justify-center transition-all flex-row flex font-line font-normal hover:bg-teal-600 text-white py-4 px-8 rounded-xl"
            }, _hoisted_24, 8, _hoisted_21))
          : _createCommentVNode("", true)
      ]),
      (_ctx.status == 'ready')
        ? (_openBlock(), _createElementBlock("div", _hoisted_25, "Check avatars"))
        : _createCommentVNode("", true),
      (_ctx.status == 'wait_for_photos')
        ? (_openBlock(), _createElementBlock("div", _hoisted_26, _hoisted_28))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_29, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.photos, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: "p-2 my_photo_border rounded-2xl mr-2 mb-2"
          }, [
            _createElementVNode("img", {
              class: "w-[200px] rounded-2xl",
              src: item.fullPath
            }, null, 8, _hoisted_30)
          ]))
        }), 128))
      ])
    ])
  ]))
}